import { FC } from 'react'
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'

import * as atoms from 'src/atoms/user-lists/user-lists-modal'
import { UserList, UserListItemType } from 'src/common-services'
import { SearchableModal } from 'src/components/searchable-modal'
import { Content } from 'src/components/user-lists-modal/content'
import { Header } from 'src/components/user-lists-modal/header'

export type UserListModalListItemType = 'list' | UserListItemType

type UserListModalProps = {
  onInsertListInMapBuilder?: (list: UserList) => void
  insertingListLoading?: boolean
}

export const UserListsModal: FC<UserListModalProps> = ({ insertingListLoading, onInsertListInMapBuilder }) => {
  const [open, setOpen] = useRecoilState(atoms.open)
  const setListFilter = useSetRecoilState(atoms.listFilter)
  const setSelectedListId = useSetRecoilState(atoms.selectedListId)
  const currentSection = useRecoilValue(atoms.currentSection)
  const resetUploadSection = useResetRecoilState(atoms.uploadSection)
  const resetMatchedData = useResetRecoilState(atoms.matchedData)
  const resetCsvFile = useResetRecoilState(atoms.csvFile)

  const handleClose = () => {
    setOpen(false)
    setListFilter('')
    setSelectedListId(null)
    resetUploadSection()
    resetMatchedData()
    resetCsvFile()
  }

  return (
    <SearchableModal
      open={open}
      onClose={handleClose}
      onFilterChange={setListFilter}
      minHeight={224}
      width={600}
      variant="primary"
      placeholder="Search in your lists..."
      hideSearch={currentSection !== 'user-lists' && currentSection !== 'user-list-detail'}
      header={
        <Header insertingListLoading={insertingListLoading} onInsertListInMapBuilder={onInsertListInMapBuilder} />
      }>
      <Content />
    </SearchableModal>
  )
}
